// Adds “ — Sold out” in variant dropdown options + disables sold-out pills (Udesly/Webflow → Shopify)

(function () {
  "use strict";

  function markSoldOut() {
    // 1) Variant dropdowns (option1/option2/option3)
    document.querySelectorAll('form[data-node-type="commerce-add-to-cart-form"] select[name^="option"]').forEach((select) => {
      const form = select.closest('form[data-node-type="commerce-add-to-cart-form"]');
      if (!form) return;

      // Udesly injects JSON variation config in a <script> inside the form
      const script = form.querySelector("script");
      if (!script) return;

      let variants;
      try {
        variants = JSON.parse(script.textContent || "[]");
      } catch (e) {
        return;
      }
      if (!Array.isArray(variants) || !variants.length) return;

      // Build sold-out set for option1/2/3 values (only for variants matching current partial selection)
      const fd = new FormData(form);
      const selected1 = fd.get("option1") || "";
      const selected2 = fd.get("option2") || "";
      const selected3 = fd.get("option3") || "";

      // Which option index is this select?
      const name = select.getAttribute("name"); // option1/option2/option3
      const idx = name === "option1" ? 1 : name === "option2" ? 2 : 3;

      // Helper: does a variant match the current selection excluding the option we’re labeling?
      function matchesOtherSelected(v) {
        if (idx !== 1 && selected1 && v.option1 !== selected1) return false;
        if (idx !== 2 && selected2 && v.option2 !== selected2) return false;
        if (idx !== 3 && selected3 && String(v.option3 || "") !== String(selected3 || "")) return false;
        return true;
      }

      // For each option value shown in this dropdown, decide if ALL matching variants are unavailable
      const optionEls = Array.from(select.options);
      optionEls.forEach((opt) => {
        const rawValue = opt.value;
        if (!rawValue) return;

        // Strip any previous suffix
        const cleanLabel = opt.textContent.replace(/\s*—\s*Sold out\s*$/i, "");
        opt.textContent = cleanLabel;

        const matching = variants.filter((v) => {
          if (!matchesOtherSelected(v)) return false;
          if (idx === 1) return v.option1 === rawValue;
          if (idx === 2) return v.option2 === rawValue;
          return String(v.option3 || "") === String(rawValue || "");
        });

        if (!matching.length) return;

        const allSoldOut = matching.every((v) => v.available === false);

        if (allSoldOut) {
          opt.textContent = cleanLabel + " — Sold out";
        }
      });
    });

    // 2) Pills (disable + add sold out text) — option1 pills are common in Udesly
    document.querySelectorAll('form[data-node-type="commerce-add-to-cart-form"] .w-commerce-commerceaddtocartoptionpill').forEach((pill) => {
      // Udesly uses .w--ecommerce-pill-disabled on sold out for 1-pill-group setups
      if (pill.classList.contains("w--ecommerce-pill-disabled")) {
        const labelEl = pill.querySelector("*") || pill;
        const txt = (labelEl.textContent || "").replace(/\s*—\s*Sold out\s*$/i, "");
        labelEl.textContent = txt + " — Sold out";
      } else {
        const labelEl = pill.querySelector("*") || pill;
        const txt = (labelEl.textContent || "");
        if (/—\s*Sold out\s*$/i.test(txt)) {
          labelEl.textContent = txt.replace(/\s*—\s*Sold out\s*$/i, "");
        }
      }
    });
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", () => {
    markSoldOut();

    // Re-run when Udesly switches variant
    document.body.addEventListener("foundVariation", () => {
      setTimeout(markSoldOut, 0);
    });

    // Re-run when selects change
    document.addEventListener("change", (e) => {
      if (e.target && e.target.matches('form[data-node-type="commerce-add-to-cart-form"] select[name^="option"]')) {
        setTimeout(markSoldOut, 0);
      }
    });
  });
})();
